export default __webpack_public_path__ + "static/media/tooltip-icon.69dc25bb.svg";